"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled,
      selected = _ref.selected;
  return {
    color: disabled ? theme.disabledColor : selected ? theme.selectedNameColor : theme.nameColor,
    fontWeight: theme.numberFontWeight
  };
};

var Name = _styledComponents["default"].span(_templateObject(), function (props) {
  return base(props);
});

var _default = Name;
exports["default"] = _default;